import { render } from "./factorsDatabaseParameters.vue?vue&type=template&id=22805462&scoped=true"
import script from "./factorsDatabaseParameters.vue?vue&type=script&lang=js"
export * from "./factorsDatabaseParameters.vue?vue&type=script&lang=js"

import "./factorsDatabaseParameters.vue?vue&type=style&index=0&id=22805462&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22805462"]])

export default __exports__